<section class="title-row">
  <h2 class="typography-sub-heading" [translate]="'AddressFormComponent:EditAddressTitle'" *ngIf="!newAddress">
    Edit address
  </h2>
  <h2 class="typography-sub-heading" [translate]="'AddressFormComponent:AddAddressTitle'" *ngIf="newAddress">
    Add address
  </h2>
</section>

<form [formGroup]="addressFormGroup">
  <!-- Address Type -->
  <mat-form-field class="input-container">
    <mat-select [placeholder]="'AddressFormComponent:Type' | translate" formControlName="type">
      <mat-option [value]="'home'"><span [translate]="'AddressFormComponent:Home'">Home</span></mat-option>
      <mat-option [value]="'work'"><span [translate]="'AddressFormComponent:Work'">Work</span></mat-option>
      <mat-option [value]="'holiday_home'"
        ><span [translate]="'AddressFormComponent:HolidayHome'">Holiday home</span>
      </mat-option>
      <mat-option [value]="'other'"><span [translate]="'AddressFormComponent:Other'">Other</span></mat-option>
    </mat-select>
    <mat-error
      [translate]="'AddressFormComponent:AddressTypeErrorMsg'"
      ngxErrors="type"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please select a type of address
    </mat-error>
  </mat-form-field>

  <!-- Description -->
  <mat-form-field *ngIf="addressFormGroup.controls.type.value === 'other'" class="input-container">
    <input
      matInput
      autocomplete="off"
      name="whatever"
      formControlName="description"
      [placeholder]="'AddressFormComponent:Description' | translate"
    />
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="description"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- House number. -->
  <mat-form-field class="input-container">
    <input [placeholder]="'AddressFormComponent:HouseNumber' | translate" matInput formControlName="house_number" />
    <mat-error
      [translate]="'AddressFormComponent:HouseNumberErrorMsg'"
      ngxErrors="house_number"
      ngxError="maxlength"
      when="dirty"
      role="alert"
    >
      Maximum of 10 digits
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="house_number"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- Address line 1. -->
  <mat-form-field class="input-container">
    <input
      [placeholder]="'AddressFormComponent:AddressFirstLinePlaceholder' | translate"
      matInput
      formControlName="address_line1"
    />
    <mat-error
      [translate]="'AddressFormComponent:AddressFirstLineErrorMsg'"
      ngxErrors="address_line1"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please enter the first line of your address
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="address_line1"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- Address line 2. -->
  <mat-form-field class="input-container">
    <input
      [placeholder]="'AddressFormComponent:AddressSecondLinePlaceholder' | translate"
      matInput
      formControlName="address_line2"
    />
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="address_line2"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- City. -->
  <mat-form-field class="input-container">
    <input [placeholder]="'AddressFormComponent:AddressCityLabel' | translate" matInput formControlName="city" />
    <mat-error
      [translate]="'AddressFormComponent:AddressCityErrorMsg'"
      ngxErrors="city"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please enter your city
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="city"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- state or province -->
  <mat-form-field class="input-container">
    <input
      [placeholder]="'AddressFormComponent:AddressStateorProviceLabel' | translate"
      [required]="stateRequired"
      matInput
      formControlName="state"
    />
    <mat-error
      [translate]="'UserDetailsComponent:StateReq'"
      ngxErrors="state"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please enter your State/Province
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="state"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- country -->
  <mat-form-field class="input-container">
    <input
      type="text"
      formControlName="country"
      (blur)="checkCountry($event)"
      (keyup)="filterAutocomplete()"
      placeholder="{{ (customVariables$ | async)?.user_details_country || 'UserDetailsComponent:Country' | translate }}"
      matInput
      [matAutocomplete]="auto"
    />
    <mat-autocomplete hideSingleSelectionIndicator="true" #auto="matAutocomplete">
      <mat-option
        *ngFor="let country of filteredCountries"
        [value]="country.name"
        (onSelectionChange)="setChosenCountry(country.url)"
      >
        {{ country.name }}
      </mat-option>
    </mat-autocomplete>
    <!--error message -->
    <mat-error
      [translate]="(customVariables$ | async).address_country_error || 'AddressFormComponent:AddressCountryErrorMsg'"
      ngxErrors="country"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please select a country
    </mat-error>
  </mat-form-field>

  <!-- postcode -->
  <mat-form-field class="input-container">
    <input
      [placeholder]="'AddressFormComponent:AddressPostcodeLabel' | translate"
      matInput
      formControlName="postcode"
    />
    <mat-error
      [translate]="'AddressFormComponent:AddressPostcodeErrorMsg'"
      ngxErrors="postcode"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please enter your Zip code/Postcode
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="postcode"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- preferred -->
  <div class="row">
    <div class="col-xs-12 col-md-12 pb-1">
      <div *ngIf="(addressToEdit$ | async)?.preferred; else el_form_not_preferred">
        <ng-container>{{ 'AddressFormComponent:PreferredAddressLabel' | translate }}</ng-container>
      </div>

      <ng-template #el_form_not_preferred>
        <mat-checkbox formControlName="preferred">
          <ng-container>{{ 'AddressFormComponent:AddressPreferredAddressCheckboxLabel' | translate }}</ng-container>
        </mat-checkbox>
      </ng-template>
    </div>
  </div>
</form>

<section class="submit-row top-separator">
  <button
    *ngIf="!newAddress && !(addressToEdit$ | async)?.preferred"
    aria-label="close"
    (click)="removeAddress()"
    mat-raised-button
    class="mr-2 remove-button"
    id="delete-current-record"
  >
    {{ 'ProfileDetails:Delete' | translate }}
  </button>
  <div
    class="action-buttons"
    [ngClass]="{ 'action-buttons--has-seperator': !newAddress && !(addressToEdit$ | async)?.preferred }"
  >
    <button
      id="cancel-current-address-edit"
      aria-label="close"
      (click)="closeForm()"
      mat-raised-button
      class="close-button"
    >
      {{ 'PopupForm:Close' | translate }}
    </button>
    <button id="save-current-address-edit" aria-label="submit" (click)="submitForm()" mat-raised-button color="primary">
      {{ 'PopupForm:Submit' | translate }}
    </button>
  </div>
</section>
